import { useEffect, useState } from 'react';

const navLinks = [
  { id: '#live', label: '现场直击' },
  { id: '#feed', label: '瓜田速递' },
  { id: '#deep', label: '实况还原' },
  { id: '#trending', label: '热搜榜' },
  { id: '#guide', label: '吃瓜指南' },
  { id: '#about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70' : 'bg-transparent'}`}>
      <nav className="mx-auto flex h-16 md:h-20 items-center justify-between px-4 md:px-6" aria-label="主导航">
        {/* Logo / brand */}
        <a href="#start" className="flex items-center gap-2.5">
          <span className={`flex h-9 w-9 items-center justify-center rounded-xl ${scrolled ? 'bg-primary-500' : 'bg-background-50/20 border border-background-50/30'} font-display text-lg font-bold text-background-50`}>瓜</span>
          <span className={`font-display text-lg font-bold leading-none ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}>
            吃瓜现场
            <span className={`mt-0.5 block text-[10px] font-label font-normal tracking-wide ${scrolled ? 'text-foreground-500' : 'text-background-50/70'}`}>群众围观现场 · 实况还原</span>
          </span>
        </a>

        {/* Desktop links */}
        <div className="hidden items-center gap-7 lg:flex">
          {navLinks.map((l) => (
            <a key={l.id} href={l.id} className={`whitespace-nowrap text-sm transition-colors ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-background-50/90 hover:text-background-50'}`}>
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 lg:flex">
          <a href="#newsletter" className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${scrolled ? 'bg-primary-500 text-background-50 hover:bg-primary-600' : 'border border-background-50/40 text-background-50 hover:bg-background-50/10'}`}>
            <i className="ri-flashlight-fill" aria-hidden="true" />
            订阅瓜田晚报
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
          className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg lg:hidden ${scrolled ? 'text-foreground-950 hover:bg-background-200' : 'text-background-50 hover:bg-background-50/10'}`}
        >
          <i className={`text-xl ${open ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </nav>

      {/* Mobile panel */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-2 lg:hidden">
          <div className="flex flex-col">
            {navLinks.map((l) => (
              <a key={l.id} href={l.id} onClick={() => setOpen(false)} className="flex items-center justify-between border-b border-background-100 py-3 text-sm text-foreground-800 hover:text-primary-600">
                {l.label}
                <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true" />
              </a>
            ))}
          </div>
          <a href="#newsletter" onClick={() => setOpen(false)} className="mt-4 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600">
            <i className="ri-flashlight-fill" aria-hidden="true" /> 订阅瓜田晚报
          </a>
        </div>
      )}
    </header>
  );
}